import React from 'react';

import { Row } from 'apps/auth/components/common/Layout/Row';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { resolveArguments, toLowerCase } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import { LimitBlock } from '../gaLimits/LimitBlock';

const UsaLimits = (props) => {
    const messages = usePageMessages();
    const { isShowLimitsButton = false, button } = props;
    const getExpirationString = (cycle, totalLimitEnd) => {
        const date = new Date(totalLimitEnd);
        const month = messages[`month_${date.getMonth() + 1}_long`];
        return `${cycle} · ${resolveArguments(props.until, ` ${month} ${date.getDate()}, ${date.getFullYear()}`)}`;
    };

    const getTitle = (cycle, totalLimitEnd) =>
        cycle === 'DAILY' ? messages['limits_' + toLowerCase(cycle)] : getExpirationString(messages['limits_' + toLowerCase(cycle)], totalLimitEnd);

    return (
        <>
            {props.limits.map((limit) => (
                <Row indent="adaptive-32-48" key={limit.cycle}>
                    <LimitBlock
                        title={getTitle(limit.cycle, limit.totalLimitEnd)}
                        progressWidth={100 - limit.leftPercent}
                        isExhaustedLimit={limit.leftPercent <= 25}
                        currency={limit.currencyCode}
                        spendSum={getLocalizedRawAmount(props.lang, props.country, limit.used)}
                        spendText={props.spendText}
                        leftSum={getLocalizedRawAmount(props.lang, props.country, limit.max - limit.used)}
                        leftText={props.leftText}
                        isLimitError={limit.max === 0}
                        limitErrorText={props.limitErrorText}
                    />
                </Row>
            ))}
            {isShowLimitsButton && button}
        </>
    );
};

export default UsaLimits;
